import { connect, useSelector } from "react-redux";
import {
    ResetPasswordInput,
  ResetPasswordInputError,
  UpdatePasswordInput,
  UserProps,
} from "../../store/actionType";
import { RestUserPassword } from "../../store/action";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import PasswordReset from "./components/PasswordResetForm";

type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userData: UserProps;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleResetPassword: React.FC<Props> = ({
  closeModal,
  onResetPassword,
  userData,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<ResetPasswordInput>({
    password: "",
    confirm_password: "",
    user_id: userData.id
  });
  const userState = useSelector((state: any) => state.users.genericUserState);
  const [error, setError] = useState<ResetPasswordInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const errors: ResetPasswordInputError = {};
    if (!formData.password.trim()) errors.password = "Passowrd is required";
    if (!formData.confirm_password.trim()) errors.confirm_password = "Confirm Password is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (formData.password.trim() !== "" && formData.confirm_password.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      const input = {
        confirm_password: formData.confirm_password || "",
        password: formData.password || "",
        user_id: formData.user_id || "",
      };
      try {
        await onResetPassword(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!userState.isLoading && submitted) {
      if (userState.error) {
        setApiError(userState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [userState?.isLoading, userState?.error, submitted]);
  return (
    <>
      <PasswordReset
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Change Password"}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onResetPassword: (input: ResetPasswordInput) =>
    dispatch(RestUserPassword(input)),
});
export default connect(null, mapDispatchToProps)(HandleResetPassword);
